import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "content-wrapper" };
import { autoRefreshPageTitle } from '@/utils/vueUtils';
import vuexStore from '@/vuex-store';
import MapWrapper from './MapWrapper.vue';
import RegisteredAreaWrapper from './RegisteredAreaWrapper.vue';
// hub selector 완료 후 타이틀 셋팅
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        autoRefreshPageTitle(vuexStore);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" 지도영역 "),
                    _createVNode(MapWrapper, { class: "map" }),
                    _createCommentVNode(" 등록된 구역 목록 영역 "),
                    _createVNode(RegisteredAreaWrapper, { class: "controller" })
                ])
            ]));
        };
    }
});
